export default {
    path: '/modules/hotRenewal',
    name: 'modules-hotRenewal',
    component: () => import('@/modules/hotRenewal/pages/index.vue'),
    children: [
        {
            path: 'list',
            component: () => import('@/modules/hotRenewal/pages/list.vue'),
            meta: {
                pageTitle: '热更新管理列表',
            }
        },
        {
            path: 'view',
            component: () => import('@/modules/hotRenewal/pages/edit.vue'),
            meta: {
                pageTitle: '热更新管理',
                parent: '/modules/hotRenewal/list',
            }
        }
    ],

};